import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_TRANSACTION_WITH_SEGMENTS = gql`
  query getTransactionWithSegments($journalEntryId: ID!) {
    journalEntry(id: $journalEntryId) {
      id
      dateOfTransaction
      vendorName
      categorization {
        categorizationUIClientComment
        selectedLedgerAccount {
          id
        }
      }
      dataEntries {
        id
        amountInCents
        entryType
        ledgerAccount {
          id
          name
        }
        segmentAllocations {
          clientCategoryId
          segments {
            id
            clientSegmentId
            amount
          }
        }
      }
    }
  }
`;
